import './style.scss';
import { bootstrapTerminal } from './terminal';
import { State } from './shared';
import { Terminal } from 'xterm';
document.addEventListener('DOMContentLoaded', function () {
    var state = new State();
    state.initializeTerm(new Terminal());
    bootstrapTerminal(state);
});
